import { render } from "./LoadingButton.vue?vue&type=template&id=a4a97c96"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LoadingButton.vue"]])

export default __exports__